// extracted by mini-css-extract-plugin
export default {"landingHeader":"LandingPage_landingHeader__6xyMI"};